window.iosAutoFillIntervals = [];
window.iosAutoFillCounts = [];
window.iosAutoFillLastValues = [];

const iosautofillfix = {
    bind: function (el, binding, vnode) {
        if (navigator.userAgent.match(/chrome|chromium|crios/i) && navigator.userAgent.match(/iPhone/i)) {
            let seconds = binding.arg ? binding.arg * 60 : 60;
            let intervalTiming = 300;

            window.iosAutoFillLastValues[el.name] = el.value
            window.iosAutoFillCounts[el.name] = 0;

            window.iosAutoFillIntervals[el.name] = setInterval(() => {
                // check if the component variable is already set
                if(window.iosAutoFillLastValues[el.name] && window.iosAutoFillLastValues[el.name].length > 3) {
                    clearInterval(window.iosAutoFillIntervals[el.name]);
                    return false;
                }

                if(el.value.length > 1 && el.value !== '') {
                    vnode.elm.dispatchEvent(new CustomEvent('input'));
                    clearInterval(window.iosAutoFillIntervals[el.name]);
                    return false;
                }

                window.iosAutoFillCounts[el.name]++;

                if(window.iosAutoFillCounts[el.name]*intervalTiming > seconds*1000) {
                    clearInterval(window.iosAutoFillIntervals[el.name]);
                    return false;
                }

                window.iosAutoFillLastValues[el.name] = el.value;

            }, intervalTiming);
        }
    }
};

export default iosautofillfix;
